import { setContext } from '@apollo/client/link/context';
import { getToken, removeToken } from '@/utils/authToken.ts';
import { RetryLink } from '@apollo/client/link/retry';
import { ErrorLink } from '@apollo/client/link/error';
import { cache, persistor } from '@/utils/apolloInMemoryCache.ts';
import { ApolloClient, from } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

const authLink = setContext((_, { headers }) => {
  const token = getToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : undefined,
    },
  };
});

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 5,
    retryIf: (error) => !!error,
  },
});

const httpLink = createUploadLink({
  uri: `${import.meta.env.VITE_APP_URL}/graphql`,
});

const errorLink = new ErrorLink(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message }) => {
      if (message === 'Unauthenticated.') {
        removeToken();
        persistor.purge().then(() => {
          location.reload();
        });
        return;
      }
      enqueueSnackbar(message, {
        variant: 'error',
      });
    });
  }
});

const link = from([authLink, errorLink, retryLink, httpLink]);

const client = new ApolloClient({
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
  link,
  cache,
});

export default client;
